import styles from './ApplyBox.css'
import moment from 'moment'
import { connect } from 'react-redux'

class ApplyBox extends React.Component {
  constructor (props) {
    super(props)
    let {startDate, endDate} = this.props
    this.state = {
      startDate: startDate,
      endDate: endDate
    }
  }

  componentWillReceiveProps (props) {
    const isSameStartDate = moment(props.startDate).isSame(this.state.startDate)
    const isSameEndDate = moment(props.endDate).isSame(this.state.endDate)
    if (props.startDate && props.endDate && !(isSameEndDate && isSameStartDate)) {
      this.setState({
        startDate: props.startDate,
        endDate: props.endDate
      })
    }
  }

  render () {
    let {startDate, endDate} = this.state
    let formattedStartDate = moment(startDate).format('D/MM/YYYY')
    let formattedEndDate = moment(endDate).format('D/MM/YYYY')
    const {fullSiteMode} = this.props

    return (<div className={styles.wrapper}>
      <div className='row'>
        <div className='col-md-12'>
          <form className='form-inline'>
            <div className={`form-group ${!fullSiteMode ? styles['form-group'] : styles['mr-btn-5']}`}>
              <input
                type='text'
                className={`form-control ${!fullSiteMode ? styles.input : styles['input-mobi']}`}
                value={formattedStartDate}
              />
            </div>
            <div className={`form-group ${!fullSiteMode ? styles['form-group'] : styles['mr-btn-5']}`}>
              <input
                type='text'
                className={`form-control ${!fullSiteMode ? styles.input : styles['input-mobi']}`}
                value={formattedEndDate}
              />
            </div>
            <div className={`form-group ${!fullSiteMode ? styles['form-group'] : styles['mr-btn-5']}`}>
              <button
                className={`btn btn-primary btn-block ${!fullSiteMode ? styles['btn-apply'] : styles['input-mobi']}`}
                onClick={this._onClickApply}>
                Apply
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>)
  }

  _onClickApply = (e) => {
    // we need this to prevent keep opening of dropdown
    // because the open state needs to be set manually (from onApply)
    e.preventDefault()
    e.stopPropagation()

    const {startDate, endDate} = this.state

    this.props.onApply({
      startDate: moment(startDate).startOf('day').toISOString(),
      endDate: moment(endDate).endOf('day').toISOString()
    })
  }
}

ApplyBox.propTypes = {
  startDate: React.PropTypes.object,
  endDate: React.PropTypes.object,
  onApply: React.PropTypes.func
}

function mapStateToProps () {
  return {}
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(ApplyBox)



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/DropdownCalendarPromo/ApplyBox/ApplyBox.js